export const REVERSE_MESSAGE_TYPE_USER_INFO_FETCHED = 'user_info_fetched';
